import { HttpParams } from '@angular/common/http';
import { PageableParam } from '@rms/sdk/models';
import { createFilterParams, Filter, FilterOperator, FilterType } from '@rms/ui/filters';
import { DateTime } from 'luxon';

export function pagedParams({ page, size, sort }: PageableParam, filters: Filter[]): HttpParams {
  let params = new HttpParams({ fromObject: sort?.length ? { page, size, sort } : { page, size } });
  for (const filter of filters) {
    if (filter.type !== FilterType.DATE) {
      continue;
    }
    const from = filter.operator === FilterOperator.BEFORE ? undefined : filter.valueFrom;
    const to = filter.operator === FilterOperator.AFTER ? undefined : filter.valueTo;
    if (from) {
      params = params.append(`${filter.filter}_from`, toApiDate(from));
    }
    if (to) {
      params = params.append(`${filter.filter}_to`, toApiDate(to));
    }
  }

  return createFilterParams(
    filters.filter((filter) => filter.type !== FilterType.DATE),
    params
  );
}

function toApiDate(date: DateTime): string {
  return date.toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'");
}
